import React, { useState, useEffect } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
} from "reactstrap";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import PinInput from "react-pin-input";
import SvgImage from "../../Icons/Icons";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "./index.css";

import { useDispatch } from "react-redux";
import {
  addMoney,
  cleanAdvanceDriverList,
  clearAllDrivers,
  clearAllDriversByVrn,
  expenseSumm,
  getAdvanceDriverList,
  getDriverList,
} from "../../../services/Store/Actions/driverslistActions";
import moment from "moment";
// import { allCardsBalance } from "../../../services/Store/Actions/cardWalletAction";
import { getMasterWalletBalance } from "../../../services/Store/Actions/masterWalletActions";
import { fetchBalance } from "../../../services/Store/Actions/manageCardActions";
import { transferToCard } from "../../../services/Store/Actions/manageCardActions";
import {
  editLedgerExpense,
  getTripsNew,
  viewBankStatement,
} from "../../../services/Store/Actions/TripsAction";
import {
  sendAnalitics,
  storeMedia,
} from "../../../services/Store/Actions/appActions";

import { ClipLoader } from "react-spinners";
import { Switch } from "@material-ui/core";
import ListModal from "../../subComponents/ListModal";
import { advancedVehicleListAction } from "../../../services/Store/Actions/fleetActions";
import {
  clearAllFleets,
  getVehicleListAction,
} from "../../../services/Store/Actions/manageVehicleAction";
import SelectVendorModal from "../../Vendor/Components/Modal/SelectVendorModal";
import ProgessLoader from "../../core/ProgessBar";
const EditLedgerExpense = (props) => {
  const dispatch = useDispatch();
  const {
    open,
    toggleModal,
    handleClose,
    name,
    vehRegNo,
    openChooseMethod,
    itemTemp,
    ledgerData,
  } = props;

  // useEffect(() => {
  //   dispatch(fetchBalance());
  // }, [fleetId]);
  // const { ownerBalance } = useSelector((state) => state?.manageCard); //LOgipe CARD BALANCE
  const { allDriverList } = useSelector((state) => state?.driverlist);
  const loader1 = useSelector((state) => state?.driverlist?.loader);
  let loader2 = useSelector((state) => state?.manageVehicle?.loader);
  const { allFleetsList } = useSelector((state) => state?.manageVehicle);
  let { fetchingTrips, tripsListNew, loader } = useSelector(
    (store) => store?.trip
  );
  // useEffect(() => {}, [props]);
  const [selectVendorModal, setSelectVendorModal] = useState(false);

  const [displayDrivers, setDisplayDrivers] = useState(false);
  const [displayVehicles, setDisplayVehicles] = useState(false);
  const [displayTrip, setDisplayTrips] = useState(false);
  const [search1, setSearch1] = useState("");
  const [userId, setUserId] = useState("");
  const [fleetId, setFleetId] = useState("");
  const [search2, setSearch2] = useState("");
  const [search3, setSearch3] = useState("");
  const [search4, setSearch4] = useState("");

  const [driverColor, setDriverColor] = useState(-1);

  const [vehicleColor, setVehicleColor] = useState(-1);
  const [tripColor, setTripColor] = useState(-1);

  const expenseType = [
    { value: "Food" },
    { value: "Service" },
    { value: "Fuel" },
    { value: "Salary" },
    { value: "Fastag" },
    { value: "Others" },
    { value: "vendor" },
    { value: "omc" },
  ];
  const transferType = [{ value: "credit" }, { value: "debit" }];
  const findSearch1 = () => {
    // dispatch(clearAllDrivers());
    // dispatch(
    //   getDriverList({
    //     offset: "",
    //     search: search1,
    //     minKyc: "",
    //     sortAs: "",
    //     sortBy: "",
    //     limit: 10,
    //   })
    // );
  };

  useEffect(() => {
    let timeout;
    if (displayDrivers) {
      dispatch(clearAllDrivers());
      if (search1 == "") {
        console.log("jijijr", search1);
        dispatch(
          getDriverList({
            offset: "",
            search: search1,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          })
        );
      } else {
        timeout = setTimeout(() => {
          dispatch(
            getDriverList({
              offset: "",
              search: search1,
              minKyc: "",
              sortAs: "",
              sortBy: "",
              limit: 10,
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };
      }
    }
  }, [search1, displayDrivers]);

  const findSearch2 = () => {
    // dispatch(clearAllFleets());
    // dispatch(
    //   getVehicleListAction({
    //     offset: "",
    //     search: search2,
    //     minKyc: "",
    //     sortAs: "",
    //     sortBy: "",
    //     limit: 10,
    //   })
    // );
  };

  useEffect(() => {
    let timeout;
    if (displayVehicles) {
      dispatch(clearAllFleets());
      if (search2 == "") {
        console.log("jijijr", search2);
        dispatch(
          getVehicleListAction({
            offset: "",
            search: "",
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          })
        );
      } else {
        timeout = setTimeout(() => {
          dispatch(
            getVehicleListAction({
              offset: "",
              search: search2,
              minKyc: "",
              sortAs: "",
              sortBy: "",
              limit: 10,
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };
      }
    }
  }, [search2, displayVehicles]);

  const findSearch3 = () => {
    // dispatch(
    //   getTripsNew({
    //     offset: 0,
    //     limit: 10,
    //     isActive: "",
    //     tripNo: search3?.trim(),
    //   })
    // );
  };

  useEffect(() => {
    let timeout;
    if (displayTrip) {
      if (search3 == "") {
        console.log("jijijr", search3);
        dispatch(
          getTripsNew({
            offset: 0,
            limit: 10,
            fleetId : fleetId || "",
            driverId: userId || "",
            isActive: "",
            tripNo: search3?.trim(),
          })
        );
      } else {
        timeout = setTimeout(() => {
          dispatch(
            getTripsNew({
              offset: 0,
              limit: 10,
              isActive: "",
              fleetId : fleetId || "",
              driverId: userId || "",
              tripNo: search3?.trim(),
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };
      }
    }
  }, [search3, displayTrip]);

  useEffect(() => {
    setSearch1("");
    setSearch2("");
    setSearch3("");
    setDriverColor(-1);
    setDisplayDrivers(false);
    setDisplayVehicles(false);
    setDisplayTrips(false);
    setVehicleColor(-1);
    setTripColor(-1);
  }, []);

  const openBox1 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayDrivers(true);
  };
  const openBox2 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayVehicles(true);
  };

  const closeBox1 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayDrivers(false);
  };
  const closeBox2 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayVehicles(false);
  };

  const openBox3 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayTrips(true);
  };

  const closeBox3 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayTrips(false);
  };

  const handleKeyPress = (newSearchVal, divName) => {
    //alert("search again", newSearchVal,divName);
    console.log("search1", newSearchVal);
    console.log("search2", divName);
    dispatch(
      getAdvanceDriverList({
        offset: 0,
        search: newSearchVal.trim(),
        minKyc: "",
        sortAs: "",
        sortBy: "",
        activeStatus: "",
        assignedStatus: "",
      })
    );
  };
  // useEffect(() => {}, [fleetId]);
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={handleClose}
        className="positons settingModalMargin"
        toggle={toggleModal}
        aria-labelledby="myModalLabel2"
      >
        <div
          className="modal-content"
          style={{ width: "530px", overflowY: "scroll", overflowX: "hidden" }}
        >
          <div className="modal-head-part">
            <p className="Add-balance-title">{name}</p>
            <Button
              type="button"
              className="close-btn"
              onClick={() => {
                if (!loader) {
                  toggleModal();
                }
              }}
              aria-label="Close"
            >
              <SvgImage name="CloseButtonLogo" />
            </Button>
          </div>
          <ModalBody>
            {/* <div className="card-wallet-icon-body2">
              <SvgImage
                name="cardWalletLogo"
                height="43.81"
                width="43.81"
                classname="card-wallet-logo-BankLogo"
              />
              <div>
                <p className="body-sub-part1-ab">Master Account Balance</p>
                <p className="body-sub-part2-ab">₹{LogipeAccounBal}</p>
              </div>
            </div> */}
            {/* <div
              className="flexStyling sub-head-3"
              style={{ justifyContent: "center", marginTop: "20px" }}
            >
              <div> Cash</div>
              <div style={{ marginTop: "-7px" }}>
                <Switch
                  checked={card}
                  onChange={(e) => {
                    setCard(!card);
                  }}
                  handleDiameter={20}
                  height={15}
                  width={40}
                  id="material-switch"
                />
              </div>
              <div>Card</div>
            </div> */}
            <Formik
              enableReinitialize
              initialValues={{
                amount: ledgerData?.amount || "",
                pin: "",
                tripNo: ledgerData?.Trip?.tripNo || "",
                remark: ledgerData?.remarks || "",
                // type: ledgerData?.expanseTag || "",
                transferType:  ledgerData?.tripLedgerId ? 
                (ledgerData?.userId ? ledgerData?.driverTransferType : ledgerData?.vendorId ? ledgerData?.vendorTransferType : ledgerData?.transferType) : ledgerData?.transferType,
                expanseTag: ledgerData?.expanseTag || "",
                isDeleted: false,
                userId: "",
                fleetId: "",
                tripId: "",
                description: ledgerData?.description || "",
                givenTo: ledgerData?.tripLedgerId ? 
                          (ledgerData?.userId ? "Driver" : ledgerData?.vendorId ? "Vendor" : 
                            ledgerData?.fleetId ? "Vehicle_Expense" : "") : "",
                vendorName : ledgerData?.tripLedgerId ? 
                  (ledgerData?.userId ? ledgerData?.User?.fullName : ledgerData?.vendorId ? ledgerData?.Vendor?.name : 
                    ledgerData?.fleetId ? ledgerData?.Fleet?.regNumber : "") : "",
                vendorId : ledgerData?.tripLedgerId && ledgerData?.vendorId ? ledgerData?.Vendor?.name: "" ,  
                tripData : "",
                driverName : ledgerData?.tripLedgerId && ledgerData?.userId ? ledgerData?.User?.fullName : "",
                vrn : ledgerData?.tripLedgerId && ledgerData?.fleetId ? ledgerData?.Fleet?.regNumber : "",
                tripNo : ledgerData?.tripLedgerId && ledgerData?.tripId ? ledgerData?.Trip?.TripNo : ""
              }}
              //   validationSchema={Yup.object().shape({
              //     amount: Yup.number()
              //       .typeError("Only Numbers are allowed")
              //       .min(1, "Amount should be greater than 1")
              //       .required("Amount is required"),
              //     pin: Yup.string()
              //       .required("* Required")
              //       .matches(/^[0-9]{4}$/, "* Pin Must be exactly 4 digits"),
              //     type: Yup.string().required("* Expense Type required"),
              //     // dob: Yup.string()
              //     //   .required('Expense Date is required'),
              //     // password: Yup.string()
              //     //   .min(6, 'Password must be at least 6 characters')
              //     //   .required('Password is required'),
              //     // confirmPassword: Yup.string()
              //     //   .oneOf([Yup.ref('password'), null], 'Passwords must match')
              //     //   .required('Confirm Password is required')
              //   })}
              //validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                // values.bookingDate = moment(values.bookingDate).format(
                //   "DD-MM-YYYY"
                // );
                //console.log("date",moment(values.bookingDate).format('DD-MM-YYYY'))
                if (ledgerData?.tripLedgerId) {
                  console.log("kkkkknnannaann", values);
                  let finalData = {
                    tripLedgerId: ledgerData?.tripLedgerId,
                    amount: values?.amount ? values?.amount : "",
                    tripNo: values.tripNo ? values.tripNo : "",
                    tripId: values.tripId ? values.tripId : "",
                    expanseTag: values.expanseTag ? values.expanseTag : "",
                    // expanseType: values?.expanseType ? values?.expanseType : "",
                    isDeleted: values?.isDeleted,
                    fleetId: values.fleetId || "",
                    userId: values.userId || "",
                    driverName: "",
                    vrn: "",
                    vendorId : values.vendorId || "",
                    remarks : values?.remark || "",
                  };
                  // if (values?.tripId) {
                  //   finalData["tripId"] = values?.tripId;
                  // }

                  // if (values?.otherRemarks) {
                  //   finalData["otherRemarks"] = values?.otherRemarks;
                  // }
                  dispatch(
                    editLedgerExpense(finalData, (res) => {
                      actions.setSubmitting(false);
                      // dispatch(
                      //   sendAnalitics("Success_Add_Bal_DriverCard_Web", {
                      //     amt: values.amount,
                      //     pin: values.pin,
                      //     remark: values.remark,
                      //     fleetId: fleetId,
                      //   })
                      // );
                      if (res?.status == 200) {
                        console.log("successful");
                        //navigate("/Customers")
                        // dispatch(expenseSumm(fleetId));
                        // window.location.reload();
                        toggleModal();
                      }
                    })
                  );
                } else if (ledgerData?.bankLedgerId) {
                  console.log("kkkkknnannaann", values);
                  let finalData = {
                    ...ledgerData,
                    amount: values?.amount ? values?.amount : "",
                    tripNo: values.tripNo ? values.tripNo : "",
                    tripId: values.tripId ? values.tripId : "",
                    // expanseTag : values.type ? values.type : "",
                    transferType: values?.transferType
                      ? values?.transferType
                      : "",
                    expanseTag: values?.expanseTag ? values?.expanseTag : "",
                    isDeleted: values?.isDeleted,
                    fleetId: values?.givenTo == "Vehicle_Expense" ? values.fleetId : "",
                    userId: values?.givenTo == "Driver" ? values.userId : "",
                    driverName: "",
                    vrn: "",
                    isNew: 1,
                    vendorId :values?.givenTo == "Vendor" ? values.vendorId : "",
                    refData : {
                      fleetId : values?.fleetId || "",
                      tripId : values?.tripId || "",
                      userId : values?.userId || "",
                      vrn : values?.vrn || "",
                      driverName : values?.driverName || "",
                      vendorId : values?.vendorId || "",
                      vendorName : values?.vendorName || "",
                      tripData :  values?.tripData || "",
                      givenTo : values?.tripId ? "Trip" : values?.givenTo,
                    }
                  };
                  // if (values?.tripId) {
                  //   finalData["tripId"] = values?.tripId;
                  // }

                  // if (values?.otherRemarks) {
                  //   finalData["otherRemarks"] = values?.otherRemarks;
                  // }
                  dispatch(
                    editLedgerExpense(finalData, (res) => {
                      actions.setSubmitting(false);
                      // dispatch(
                      //   sendAnalitics("Success_Add_Bal_DriverCard_Web", {
                      //     amt: values.amount,
                      //     pin: values.pin,
                      //     remark: values.remark,
                      //     fleetId: fleetId,
                      //   })
                      // );
                      if (res?.status == 200) {
                        console.log("successful");
                        dispatch(
                          viewBankStatement({
                            offset: 0,
                            limit: 10,
                            bankId: props?.bankId || "",
                            sortBy: "expDate",
                            sortAs: props?.sortDirection == "asc" ? "ASC" : "",
                            from: props?.from,
                            to: props?.to,
                            transferType: props?.transferType,
                            mode: props?.mode,
                            offset: props?.offset,
                          })
                        );
                        //navigate("/Customers")
                        // dispatch(expenseSumm(fleetId));
                        // window.location.reload();
                        toggleModal();
                      }
                    })
                  );
                } else {
                  toast.error("please select user again.");
                }

                //   // addMoney(values, fleetId, (res) => {
                //   //   actions.setSubmitting(false);
                //   //   if (res?.data?.type === "success") {
                //   //     console.log("successful");
                //   //     //navigate("/Customers")
                //   //     dispatch(expenseSumm(fleetId));
                //   //     toggleModal();
                //   //   }
                //   // })
                // );
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                /* and other goodies */
              }) => (
                <Form onSubmit={handleSubmit}>
                  <div>
                    <div className="sub-title-1">
                      {/* <span class="circle-logo">1</span> */}
                      <input
                        type="checkbox"
                        className=" form-check-input circle-logo2"
                        checked={values.isDeleted}
                        value="allOptions"
                        onChange={(e) => {
                          const { checked } = e.target;
                          setFieldValue("isDeleted", checked, true);
                        }}
                      />
                      <p className="sub-head-3">
                        Do you want to Delete Expense
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">1</span>
                      <p className="sub-head-3">Enter amount</p>
                    </div>
                    <p className="sub-head-body">
                      Amount will be deducted from owner’s LogiPe account
                    </p>

                    <input
                      type="text"
                      id="html"
                      className={
                        "input-body-1 form-control" +
                        (errors.amount && touched.amount ? " is-invalid" : "")
                      }
                      name="amount"
                      value={values.amount}
                      touched={touched.amount}
                      errors={errors.amount}
                      onBlur={handleBlur("amount")}
                      onChange={handleChange("amount")}
                    ></input>
                    <div className="input-amount"></div>
                    <ErrorMessage
                      name="amount"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>

                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">2</span>
                      <p className="sub-head-3">Description</p>
                    </div>
                    <p className="sub-head-body">
                      Enter Description Number to Add This Expense
                    </p>

                    <input
                      type="text"
                      id="description"
                      // readonly="readonly"
                      className={
                        "input-body-1 form-control" +
                        (errors.description && touched.description
                          ? " is-invalid"
                          : "")
                      }
                      name="description"
                      value={values.description}
                      // touched={touched.vehRegNo}
                      // errors={errors.vehRegNo}
                      // onBlur={handleBlur("vehRegNo")}
                      onChange={handleChange("description")}
                    />
                    <div className="input-amount"></div>
                    {/* <ErrorMessage
                      name="vehRegNo"
                      component="div"
                      className="invalid-feedback"
                    /> */}
                  </div>

                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">3</span>
                      <p className="sub-head-3">{"Given To"}</p>
                    </div>
                    <select
                      name="givenTo"
                      class="form-select select-option"
                      aria-label="Default select example"
                      className={
                        "input-body-3 form-control" +
                        (errors.givenTo && touched.givenTo ? " is-invalid" : "")
                      }
                      value={values.givenTo}
                      defaultValue={values.givenTo}
                      onChange={(e) => {
                        setFieldValue("givenTo", e.target.value, true);
                        // if (e.target.value == "Driver") {
                        //   setFieldValue("id", userId, true);
                        // }
                      }}
                    >
                      <option value="" disabled selected>
                        --Select--
                      </option>
                      <option value="Driver">Driver</option>
                      <option value="Vehicle_Expense">Vehicle Expense</option>
                      <option value="Vendor">Vendor</option>
                      {/* <option value="3">Others</option> */}
                    </select>
                    <div className="input-amount-for-link"></div>
                    <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.givenTo && touched.givenTo ? (
                        <div>*{errors.givenTo}</div>
                      ) : null}
                    </div>
                  </FormGroup>

                  {values?.givenTo == "Driver" ? (
                    <FormGroup>
                      <div className="sub-title-1">
                        <span class="circle-logo-2"></span>
                        <p className="sub-head-3">Search Driver</p>
                      </div>
                      <label for="html" className="label-body"></label>
                      <input
                        type="text"
                        // disabled={values?.tripId ? true : false}
                        id="driverName"
                        className="input-body-3"
                        name="driverName"
                        onFocus={() => {
                          findSearch1();
                          openBox1();
                        }}
                        style={{ marginLeft: "0" }}
                        onChange={(event) => {
                          findSearch1();
                          setDisplayDrivers(true);
                          // dispatch(clearAllDrivers());
                          dispatch(
                            sendAnalitics("Search_DC_MA_Web", {
                              searchDriverName: event.target.value,
                            })
                          );
                          console.log("eeeeeeeeeeeeeeeee", event.target.value);
                          // setDisplay(true);
                          setSearch1(event.target.value);
                          // setLoading(true);
                          setFieldValue("driverName", event.target.value, true);
                          if (event.target.value == "") {
                            setUserId("")
                            setFieldValue("userId", "", true);
                          }
                        }}
                        value={values.driverName}
                        onBlur={() => {
                          console.log("===>>>>>kkkkk");
                          handleBlur("driverName");
                          closeBox1();
                        }}
                        touched={touched.driverName}
                        errors={errors.driverName}
                        onKeyUp={(e) => {
                          if (e.key === "Backspace") {
                            findSearch1();
                          }
                        }}
                        autocomplete="off"
                        placeholder="Search driver's name"
                      />
                      <div className="input-amount">
                        {displayDrivers ? (
                          <ListModal
                            placeholder="Search"
                            handleKeyPress={handleKeyPress}
                            divName="DriverList"
                            // text="Select by driver name"
                            listing={allDriverList}
                            // handlingDivSelect={handlingDivSelect}
                            displayDrivers={displayDrivers}
                            setDisplayDrivers={setDisplayDrivers}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={driverColor}
                            setColor={setDriverColor}
                            loading={loader1}
                            setFieldValue={setFieldValue}
                            userId={userId}
                            setUserId={setUserId}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </FormGroup>
                  ) : values?.givenTo == "Vehicle_Expense" ? (
                    <FormGroup>
                      <div className="sub-title-1">
                        <span class="circle-logo-2"></span>
                        <p className="sub-head-3">Search Vehicle Number</p>
                      </div>
                      <label for="html" className="label-body"></label>
                      <input
                        type="text"
                        // disabled={values?.tripId ? true : false}
                        id="vrn"
                        className="input-body-3"
                        name="vrn"
                        style={{ marginLeft: "0" }}
                        autocomplete="off"
                        onFocus={() => {
                          findSearch2();
                          openBox2();
                        }}
                        onBlur={closeBox2}
                        onChange={(event) => {
                          findSearch2();
                          // setDisplay2(true);
                          // dispatch(clearAllDrivers());
                          dispatch(clearAllDriversByVrn());
                          dispatch(
                            sendAnalitics("Search_DC_MA_Web", {
                              searchDriverName: event.target.value,
                            })
                          );
                          console.log("eeeeeeeeeeeeeeeee", event.target.value);
                          // setDisplay(true);
                          setSearch2(event.target.value);
                          setFieldValue("vrn", event.target.value, true);
                          if (event.target.value == "") {
                            setFleetId("")
                            setFieldValue("fleetId", "", true);
                          }
                        }}
                        value={values.vrn}
                        // onBlur={handleBlur("vrn")}
                        touched={touched.vrn}
                        errors={errors.vrn}
                        onKeyUp={(e) => {
                          if (e.key === "Backspace") {
                            findSearch2();
                          }
                        }}
                        placeholder="Search Vehicle's Number"
                      />
                      <div className="input-amount">
                        {displayVehicles ? (
                          <ListModal
                            placeholder="Search"
                            handleKeyPress={handleKeyPress}
                            divName="vehicleList"
                            // text="Select by driver name"
                            listing={allFleetsList}
                            // handlingDivSelect={handlingDivSelect}
                            displayDrivers={displayVehicles}
                            setDisplayDrivers={setDisplayVehicles}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={vehicleColor}
                            setColor={setVehicleColor}
                            loading={loader2}
                            setFieldValue={setFieldValue}
                            setFleetId={setFleetId}
                          />
                        ) : (
                          <></>
                        )}
                      </div>

                      {/* <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.vrn && touched.vrn ? (
                        <div>*{errors.vrn}</div>
                      ) : null}
                    </div> */}
                    </FormGroup>
                  ) : values?.givenTo == "Vendor" ?                     <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo-2"></span>
                    <label className="sub-head-3 ">Vendor</label>
                  </div>
                  <input
                    type="text"
                    id="vendorName"
                    className={
                      "input-body-3 form-control" +
                      (errors.vendorName && touched.vendorName
                        ? " is-invalid"
                        : "")
                    }
                    // style={{ marginLeft: "94px" }}
                    name="vendorName"
                    value={values.vendorName}
                    touched={touched.vendorName}
                    errors={errors.vendorName}
                    onBlur={handleBlur("vendorName")}
                    onChange={handleChange("vendorName")}
                    placeholder="Select A Vendor"
                    autoFocus
                    onClick={() => {
                      setSelectVendorModal(true);
                    }}
                  />

                  {/* <div className="input-id-for-link"></div> */}
                  <div className="input-amount-for-link"></div>
                  <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                    {errors.vendorName && touched.vendorName ? (
                      <div>*{errors.vendorName}</div>
                    ) : null}
                  </div>
                </FormGroup>
                    : <></>
                  }


                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">4</span>
                      <p className="sub-head-3">Search Trip Number</p>
                    </div>
                    <label for="html" className="label-body"></label>
                    <input
                      type="text"
                      id="tripNo"
                      className="input-body-3"
                      name="tripNo"
                      onFocus={() => {
                        findSearch3();
                        openBox3();
                      }}
                      style={{ marginLeft: "0" }}
                      onChange={(event) => {
                        findSearch3();
                        setDisplayTrips(true);
                        // dispatch(clearAllDrivers());
                        dispatch(
                          sendAnalitics("Search_DC_MA_Web", {
                            searchDriverName: event.target.value,
                          })
                        );
                        console.log("eeeeeeeeeeeeeeeee", event.target.value);
                        // setDisplay(true);
                        setSearch3(event.target.value);
                        // setLoading(true);
                        setFieldValue("tripNo", event.target.value, true);
                        if (event.target.value == "") {
                          setFieldValue("tripId", "", true);
                          setFieldValue("tripData", "", true);
                        }
                      }}
                      value={values.tripNo}
                      onBlur={() => {
                        console.log("===>>>>>kkkkk");
                        handleBlur("tripNo");
                        closeBox3();
                      }}
                      touched={touched.tripNo}
                      errors={errors.tripNo}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          findSearch3();
                        }
                      }}
                      autocomplete="off"
                      placeholder="Search Trip's name"
                    />
                    <div className="input-amount">
                      {displayTrip ? (
                        <ListModal
                          placeholder="Search"
                          handleKeyPress={handleKeyPress}
                          divName="trip"
                          // text="Select by driver name"
                          listing={tripsListNew}
                          // handlingDivSelect={handlingDivSelect}
                          displayDrivers={displayTrip}
                          setDisplayDrivers={setDisplayTrips}
                          // displayVehicles={displayVehicles}
                          // setDisplayVehicles={setDisplayVehicles}
                          color={tripColor}
                          setColor={setTripColor}
                          loading={fetchingTrips}
                          setFieldValue={setFieldValue}
                          userId={userId}
                          setUserId={setUserId}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </FormGroup>

                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">5</span>
                      <p className="sub-head-3">Enter remarks</p>
                    </div>
                    <p className="sub-head-body">
                      Enter the the remarks/comments
                    </p>

                    <input
                      type="text"
                      id="html"
                      className={
                        "input-body-1 form-control" +
                        (errors.remark && touched.remark ? " is-invalid" : "")
                      }
                      name="remark"
                      value={values.remark}
                      touched={touched.remark}
                      errors={errors.remark}
                      onBlur={handleBlur("remark")}
                      onChange={handleChange("remark")}
                    ></input>
                    <div className="input-amount"></div>
                    <ErrorMessage
                      name="remark"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>

                  <div>
                    <div className="flexStyling">
                      <div className="sub-title-1">
                        <span class="circle-logo">6</span>
                        <p className="sub-head-3">Type</p>
                      </div>
                      <div className="sub-head-3">
                        <div className="">
                          <Field
                            component="select"
                            placeholder={"--Select--"}
                            class={
                              "form-select select-option2 broderForSelect" +
                              (errors.expanseTag && touched.expanseTag
                                ? " is-invalid"
                                : "")
                            }
                            aria-label="Default select example"
                            name="expanseTag"
                            onChange={handleChange(`expanseTag`)}
                            value={values.expanseTag}
                            onBlur={handleBlur("expanseTag")}
                            errors={errors.expanseTag}
                            touched={touched.expanseTag}
                          >
                            <option value="" disabled selected>
                              --Select--
                            </option>
                            {expenseType?.map((opt) => {
                              // console.log("lllllkkkkk",values)
                              return (
                                <option
                                  value={opt?.value}
                                  // onChange={(v) => {
                                  //   console.log("pooppppppp", v);
                                  //   // setSourceName(v?.city);
                                  //   setFieldValue(
                                  //     "vendorType",
                                  //     v?.cityName,
                                  //     true
                                  //   );
                                  //   setFieldValue(
                                  //     "vendorType",
                                  //     (v?.cityId).toString(),
                                  //     true
                                  //   );
                                  // }}
                                >
                                  {opt?.value}
                                </option>
                              );
                            })}
                          </Field>
                        </div>
                        <ErrorMessage
                          name="type"
                          component="div"
                          className="invalid-type"
                        />
                      </div>
                    </div>

                    <ErrorMessage
                      name="vehRegNo"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>

                  <div>
                    <div>
                      <div className="flexStyling">
                        <div className="sub-title-1">
                          <span class="circle-logo">7</span>
                          <p className="sub-head-3">Transfer Type</p>
                        </div>
                        <div className="sub-head-3">
                          <div className="">
                            <Field
                              disabled={props?.sortedField ? true : false}
                              component="select"
                              placeholder={"--Select--"}
                              class={
                                "form-select select-option2 broderForSelect" +
                                (errors.transferType && touched.transferType
                                  ? " is-invalid"
                                  : "")
                              }
                              aria-label="Default select example"
                              name="transferType"
                              onChange={handleChange(`transferType`)}
                              value={values.transferType}
                              onBlur={handleBlur("transferType")}
                              errors={errors.transferType}
                              touched={touched.transferType}
                            >
                              <option value="" disabled selected>
                                --Select--
                              </option>
                              {transferType?.map((opt) => {
                                // console.log("lllllkkkkk",values)
                                return (
                                  <option
                                    value={opt?.value}
                                    // onChange={(v) => {
                                    //   console.log("pooppppppp", v);
                                    //   // setSourceName(v?.city);
                                    //   setFieldValue(
                                    //     "vendorType",
                                    //     v?.cityName,
                                    //     true
                                    //   );
                                    //   setFieldValue(
                                    //     "vendorType",
                                    //     (v?.cityId).toString(),
                                    //     true
                                    //   );
                                    // }}
                                  >
                                    {opt?.value}
                                  </option>
                                );
                              })}
                            </Field>
                          </div>
                          <ErrorMessage
                            name="type"
                            component="div"
                            className="invalid-type"
                          />
                        </div>
                      </div>

                      <ErrorMessage
                        name="vehRegNo"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Button
                      type="submit"
                      className="butt4"
                      disabled={loader ? true : false}
                      onClick={() => {
                        dispatch(
                          sendAnalitics("Add_Bal_DriverCard_fromMA_Web", {
                            amt: values.amount,
                            pin: values.pin,
                            remark: values.remark,
                            fleetId: fleetId,
                          })
                        );
                      }}
                    >
                      {loader ? (
                        <>
                              <ProgessLoader
                              />
                        </>
                      ) : (
                        "Edit"
                      )}
                    </Button>
                  </div>
                  {selectVendorModal && (
                                    <SelectVendorModal
                                      open={selectVendorModal}
                                      onHide={() => {
                                        setSelectVendorModal(false);
                                      }}
                                      toggleModal={() => {
                                        setSelectVendorModal(!selectVendorModal);
                                      }}
                                      handleClose={() => {
                                        setSelectVendorModal(false);
                                      }}
                                      onClickItem={(data) => {
                                        // setVendorData({});
                                        // setVendorData(data);
                                        console.log("dadatata", data);
                                        setFieldValue("vendorName", data?.name, false);
                                        setFieldValue("vendorId", data?.id, false);
                                        setSelectVendorModal(false);
                                      }}
                                      search={search4}
                                      setSearch={setSearch4}
                                    />
                                  )}
                </Form>
              )}
            </Formik>
          </ModalBody>
        </div>
        <ToastContainer
          theme="light"
          position="top-right"
          closeOnClick
          pauseOnHover
          autoClose={4000}
        />
      </Modal>
    </div>
  );
};
export default EditLedgerExpense;
